/**
 *
 * @param {loan_amount: number, loan_duration: number} data
 * @returns {Promise<void>}
 */
import axios from "axios";

export const calculateApi = async (data) => {
    try {
        const response = await axios.post('/api/calculate', data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

calculateApi.view = async (view, data) => {
    try {
        const response = await axios.post(`/calculator/${view}`, data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

calculateApi.stepsView = async (view, data) => {
    try {
        const response = await axios.post(`/calculator/steps/${view}`, data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
